// src/components/common/Alert.js
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const Alert = ({ type, message, onClose }) => {

    const { t } = useLanguage();

    const types = {
        success: 'bg-green-50 text-green-800 border-green-400',
        error: 'bg-red-50 text-red-800 border-red-400',
        warning: 'bg-yellow-50 text-yellow-800 border-yellow-400',
        info: 'bg-blue-50 text-blue-800 border-blue-400',
    };

    if (!message) return null;

    return (
        <div className={`${types[type] || types.info} p-4 rounded-md border mb-4`}>
            <div className="flex">
                <div className="flex-grow">
                    <p className="text-sm">{message}</p>
                </div>
                {onClose && (
                    <div className="ml-auto pl-3">
                        <div className="-mx-1.5 -my-1.5">
                            <button
                                onClick={onClose}
                                className="inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2"
                            >
                                <span className="sr-only">{t('dismiss')}</span>
                                <svg
                                    className="h-5 w-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Alert;